import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-point-down': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M188.8 512C234.4 512 272 474.2 272 428.8V393.2A93.1-93.1 0 0 1 294.1 385.2C316.1 387.7 339 381.7 356.9 369.2 409.3 368.1 448 331.8 448 269.3V248C448 187.9 408 149.5 408 120.8V118.1C413 112.4 416 104.6 416 96V32C416 14.3 403.1 0 387.2 0H156.8C140.9 0 128 14.3 128 32V96C128 104.6 131 112.4 136 118.1V120.8C136 127.8 129.8 135.7 112.3 151L112.2 151.1 112 151.2C102.1 160.1 91.2 169.4 78.8 177.1 48.5 195.8 0 207.5 0 252.8 0 309.7 35.3 344.8 83.2 344.8 91.2 344.8 98.7 344 105.6 342.6V428.8C105.6 473.9 143.7 512 188.8 512zM188.8 464C170.1 464 153.6 447.2 153.6 428.8V270.4C136.3 270.4 118.4 296.8 83.2 296.8 56.8 296.8 48 276.2 48 252.8 48 244 80.7 232.4 104.1 217.9 118.7 208.8 131.3 198.3 144 187.1 162.3 171 180.6 153.2 183.6 128H360.3C364.1 170.8 400 202.5 400 248V269.3C400 309.8 377.8 326.4 338.7 319.9 330.7 334.5 304.7 344.1 285.1 332.8 266.8 352.2 238.7 350.6 224 337.8V428.8C224 447.8 207.8 464 188.8 464zM328 64C328 50.7 338.7 40 352 40S376 50.7 376 64 365.3 88 352 88 328 77.3 328 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-point-down.js
// module id = mO6B
// module chunks = 144